<template>
    <div class="layout_wrapper">
        <el-container>
            <el-header style="height: 100%;">
                <headerCom></headerCom>
            </el-header>
            <el-main>
                <router-view></router-view>
            </el-main>
            <el-footer>
                <footerCom></footerCom>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
import headerCom from "@/components/HeaderMax.vue"
import footerCom from "@/components/FooterCom.vue"
export default {
    components: {
        headerCom, footerCom
    },

}
</script>

<style lang="less" scoped>
.layout_wrapper {

    /deep/.el-header,
    .el-main,
    .el-footer {
        padding: 0;
    }

}
</style>